import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const RightArrowIcon = ({tintColor = '#001533', ...props}) => {
  return (
    <Svg
      width={7}
      height={10}
      viewBox="0 0 7 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.97.47a.75.75 0 011.06 0l4 4a.75.75 0 010 1.06l-4 4A.75.75 0 01.97 8.47L4.44 5 .97 1.53a.75.75 0 010-1.06z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default RightArrowIcon;
